import { normalize } from 'normalizr'
import { Schemas } from 'redux-modules/schema'
import { updateEntities, deleteEntity } from 'redux-modules/entity'

import api from 'api'

const FETCH_REQUEST = 'realhub/image/FETCH_REQUEST'
const FETCH_SUCCESS = 'realhub/image/FETCH_SUCCESS'
const FETCH_FAILURE = 'realhub/image/FETCH_FAILURE'
const CREATE_REQUEST = 'realhub/image/CREATE_REQUEST'
const CREATE_SUCCESS = 'realhub/image/CREATE_SUCCESS'
const CREATE_FAILURE = 'realhub/image/CREATE_FAILURE'
const UPDATE_REQUEST = 'realhub/image/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'realhub/image/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'realhub/image/UPDATE_FAILURE'
const DELETE_REQUEST = 'realhub/image/DELETE_REQUEST'
const DELETE_SUCCESS = 'realhub/image/DELETE_SUCCESS'
const DELETE_FAILURE = 'realhub/image/DELETE_FAILURE'

// Initial State
const initialState = {
  creating: false,
  deleting: false,
  errors: [],
  loaded: false,
  loading: false,
  loadedImagesForEntities: [],
  updating: false,
}

// Actions
export function fetchRequest(payload = {}){
  return {
    type: FETCH_REQUEST,
    loadedImagesForEntities: payload.loadedImagesForEntities,
  }
}

export function fetchSuccess(){
  return {
    type: FETCH_SUCCESS,
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function createRequest(){
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess(){
  return {
    type: CREATE_SUCCESS,
  }
}

export function createFailure(errors = []){
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function updateRequest(){
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess(){
  return {
    type: UPDATE_SUCCESS,
  }
}

export function updateFailure(errors = []){
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

export function deleteRequest(){
  return {
    type: DELETE_REQUEST,
  }
}

export function deleteSuccess(){
  return {
    type: DELETE_SUCCESS,
  }
}

export function deleteFailure(errors = []){
  return {
    type: DELETE_FAILURE,
    errors,
  }
}

// Helper Functions
const handleError = errors => errors || ['Something went wrong']

// Action Creators
export function loadEntityImages(entityType, entityId, options){
  let url
  switch (entityType){
    default:
      url = `/admin/image_libraries/${entityId}/images.json`
      break
  }

  const entityKey = `${entityType}${entityId}`

  return (dispatch, getState) => {
    // Set Loading
    const loadedImagesForEntities = getState().images.loadedImagesForEntities
      ? getState().images.loadedImagesForEntities.slice()
      : []
    const index = loadedImagesForEntities.indexOf(entityKey)
    if (index === -1){
      loadedImagesForEntities.push(entityKey)
    }

    dispatch(fetchRequest({ loadedImagesForEntities }))

    const promise = api(url, options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }
        const normalizedJson = normalize(json, Schemas.IMAGE_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess())
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(fetchFailure(errors))
      })
    return promise
  }
}

export function addImage(image){
  const normalizedJson = normalize(image, Schemas.IMAGE)

  return (dispatch) => {
    dispatch(updateEntities(normalizedJson))
  }
}

export function createImage(image, options){
  const config = {
    method: 'POST',
    body: JSON.stringify({
      image,
    }),
  }

  return (dispatch) => {
    dispatch(createRequest())

    const promise = api('/admin/images.json', options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.IMAGE)
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess())

        return { success: true, result: json }
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(createFailure(errors))

        return { success: false, result: errors }
      })

    return promise
  }
}

export function removeImage(image){
  const normalizedJson = normalize(image, Schemas.IMAGE)

  return (dispatch) => {
    dispatch(deleteEntity(normalizedJson))
  }
}

export function updateImage(image, options, callback){
  const config = {
    method: 'PUT',
    body: JSON.stringify({
      image,
    }),
  }

  return (dispatch) => {
    // Set Loading
    dispatch(updateRequest())

    const promise = api(`/admin/images/${image.id}.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }
        const normalizedJson = normalize(json, Schemas.IMAGE)
        dispatch(updateEntities(normalizedJson))
        dispatch(updateSuccess())

        if (callback) callback(json)

        return json
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(updateFailure(errors))
      })
    return promise
  }
}

export function copyImageToEntity(originalImage, newImage, options, callback){
  const config = {
    method: 'POST',
    body: JSON.stringify({
      image: newImage,
    }),
  }

  return (dispatch) => {
    // Set Loading
    dispatch(createRequest())

    const promise = api(`/admin/images/${originalImage.id}/copy_to_entity.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.IMAGE)
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess())

        if (callback) callback(json)

        return json
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(createFailure(errors))
      })

    return promise
  }
}

export function deleteImage(image, options, callback){
  const config = {
    method: 'DELETE',
  }

  return (dispatch) => {
    // Set Loading
    dispatch(deleteRequest())

    const promise = api(`/admin/images/${image.id}.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }
        const normalizedJson = normalize(json, Schemas.IMAGE)
        dispatch(deleteEntity(normalizedJson))
        dispatch(deleteSuccess())

        if (callback) callback(json)

        return json
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(deleteFailure(errors))
      })
    return promise
  }
}

export function updateImageSortOrder(imageIds, options){
  const config = {
    method: 'PUT',
    body: JSON.stringify({
      sort_order: imageIds,
    }),
  }

  return (dispatch) => {
    // Set Loading
    dispatch(updateRequest())

    const promise = api('/admin/images/update_sort_order.json', options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.IMAGE_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(updateSuccess())

        return json
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(updateFailure(errors))
      })

    return promise
  }
}

// Reducers
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case FETCH_REQUEST:
      return {
        ...state,
        loading: true,
        loadedImagesForEntities: action.loadedImagesForEntities || state.loadedImagesForEntities,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        errors: [],
      }
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        errors: action.errors,
      }
    case CREATE_REQUEST:
      return { ...state, creating: true }
    case CREATE_SUCCESS:
      return {
        ...state,
        creating: false,
        errors: [],
      }
    case CREATE_FAILURE:
      return {
        ...state,
        creating: false,
        errors: action.errors,
      }
    case UPDATE_REQUEST:
      return {
        ...state,
        updating: true,
      }
    case UPDATE_SUCCESS:
      return {
        ...state,
        updating: false,
        errors: [],
      }
    case UPDATE_FAILURE:
      return {
        ...state,
        updating: false,
        errors: action.errors,
      }
    case DELETE_REQUEST:
      return { ...state, deleting: true }
    case DELETE_SUCCESS:
      return {
        ...state,
        deleting: false,
        errors: [],
      }
    case DELETE_FAILURE:
      return { ...state, deleting: false }
    default:
      return state
  }
}
